// extracted by mini-css-extract-plugin
export default {"editor":"ip-holder-editor_editor__o5q29","formContainer":"ip-holder-editor_formContainer__XHM5C","list":"ip-holder-editor_list__Tai58"};